'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Element2 = require('./Element');

var _Element3 = _interopRequireDefault(_Element2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PLACEHOLDER_VALUE = ''; // null and undefined is uncontrolled value

var Select = (_temp = _class = function (_Element) {
  (0, _inherits3.default)(Select, _Element);

  function Select(props, context) {
    (0, _classCallCheck3.default)(this, Select);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Element.call(this, props, context));

    _this.onChange = function (evn) {
      evn.stopPropagation();

      var nodes = evn.target.options || [];
      var options = _this.state.options;
      var values = [];

      for (var index = 0; index < nodes.length; index++) {
        var node = nodes[index];

        if (!node.selected) {
          continue;
        }

        var optionValue = node.value;
        if (typeof optionValue === 'undefined' || !optionValue.length) {
          continue;
        }

        var optionIndex = Number(optionValue);
        if (!options[optionIndex]) {
          continue;
        }

        values.push(options[optionIndex].value);
      }

      var isMultiple = _this.isMultiple();

      _this.setValue(isMultiple ? values : values[0]);

      var onChange = _this.props.onChange;

      if (typeof onChange === 'function') {
        onChange(evn);
      }
    };

    _this.state = {
      //   ...this.state,
      options: _this.prepareOptions(props.options)
    };
    return _this;
  }

  Select.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    this.setState({
      options: this.prepareOptions(props.options)
    });
  };

  Select.prototype.prepareOptions = function prepareOptions(options) {
    var selectOptions = [];

    if ((0, _isPlainObject2.default)(options)) {
      Object.keys(options).forEach(function (key) {
        selectOptions.push({
          value: key,
          label: options[key]
        });
      });
    } else if (Array.isArray(options)) {
      options.forEach(function (option) {
        var isObject = (0, _isPlainObject2.default)(option);

        selectOptions.push({
          value: isObject ? option.value : option,
          label: isObject ? option.label : option
        });
      });
    }

    return selectOptions;
  };

  Select.prototype.getValues = function getValues() {
    var options = this.state.options;

    var value = this.getValue();
    var placeholder = this.props.placeholder;


    var isMultiple = this.isMultiple();
    var values = [];

    options.forEach(function (option, pos) {
      if (!isMultiple && option.value === value) {
        values.push(pos);
      } else if (isMultiple && value && value.length && value.indexOf(option.value) !== -1) {
        values.push(pos);
      }
    });

    if (!values.length && placeholder) {
      values.unshift(PLACEHOLDER_VALUE);
    }

    return isMultiple ? values : values[0];
  };

  Select.prototype.renderPlaceholder = function renderPlaceholder() {
    var placeholder = this.props.placeholder;

    if (typeof placeholder === 'undefined') {
      return null;
    }

    return _react2.default.createElement(
      'option',
      { value: PLACEHOLDER_VALUE },
      placeholder
    );
  };

  Select.prototype.isMultiple = function isMultiple() {
    return !!this.props.multi || !!this.props.multiple;
  };

  Select.prototype.getClassName = function getClassName() {
    var className = this.props.className;

    return className;
  };

  Select.prototype.render = function render() {
    var options = this.state.options;
    var _props = this.props,
        path = _props.path,
        disabled = _props.disabled,
        required = _props.required;

    var values = this.getValues();

    return _react2.default.createElement(
      'select',
      {
        name: path,
        value: values,
        className: this.getClassName(),
        disabled: disabled,
        required: required,
        multiple: this.isMultiple(),
        onChange: this.onChange
      },
      this.renderPlaceholder(),
      options.map(function (option, pos) {
        return _react2.default.createElement(
          'option',
          { value: pos, key: pos },
          option.label
        );
      })
    );
  };

  return Select;
}(_Element3.default), _class.propTypes = (0, _extends3.default)({}, _Element3.default.propTypes, {
  disabled: _propTypes2.default.bool,
  className: _propTypes2.default.string
}), _temp);
exports.default = Select;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/Select.js
 ** module id = 613
 ** module chunks = 0
 **/